import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollageTemplateComponent } from './collage-template.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatGridListModule} from '@angular/material/grid-list';
import {TdoControlsModule} from '../../../../tdo-controls/tdo-controls.module';
import { CollageTemplateNameComponent } from './collage-template-name/collage-template-name.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';
import {MatCardModule} from "@angular/material/card";
import {MatDividerModule} from "@angular/material/divider";
import { LucideIconsModule } from '../../../../shared/lucide-icons.module';
//import {FlexLayoutModule} from "@angular/flex-layout";



@NgModule({
    declarations: [
        CollageTemplateComponent,
        CollageTemplateNameComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule, MatIconModule,
        LucideIconsModule, MatSnackBarModule,
        MatCheckboxModule, MatGridListModule, TdoControlsModule, MatFormFieldModule, FormsModule, MatCardModule, MatDividerModule, //FlexLayoutModule,
    ]
})
export class CollageTemplateModule { }
